import { SummaryTeenagerType, TeenagerFilterType } from 'types/search-teenager.type'
import { TeenagerType } from 'types/teenager-record.type'
import { BaseData, BaseDataContent } from '../types/base.type'
import { PageableProps } from '../types/pageable.type'
import client from './client'
import { HearingIdentificationType } from 'types/hearing-identification.type'

class TeenagerService {
  async getByFilters(
    filters: TeenagerFilterType,
    pageable: PageableProps,
  ): Promise<BaseDataContent<SummaryTeenagerType[]>> {
    const url = '/adolescente'
    const params = {
      ...filters,
      ...pageable,
    }

    return await client.get<BaseDataContent<SummaryTeenagerType[]>>(url, params).then((res) => res)
  }

  async getById(id: number): Promise<BaseData<TeenagerType>> {
    const url = `/adolescente/${id}`

    return await client.get<BaseData<TeenagerType>>(url).then((res) => res)
  }

  async update(
    id: number,
    values: HearingIdentificationType,
  ): Promise<BaseData<HearingIdentificationType>> {
    const url = `/adolescente/${id}`

    console.log('Update Adolescente ', values)
    return await client.put<BaseData<HearingIdentificationType>>(url, values).then((res) => res)
  }

  async getPicture(id: string | number): Promise<BaseData<any>> {
    const url = `/adolescente/${id}/foto`

    return await client.getBlob<BaseData<any>>(url)
  }

  async savePicture(id: number | string, foto: File): Promise<BaseData<string>> {
    const url = `/adolescente/${id}/foto`

    const formData = new FormData()
    formData.append('fotoAdolescente', foto)
    formData.append('removerFotoAdolescente', 'false')

    return await client.post<BaseData<string>>(url, formData)
  }

  async deletePicture(id: number | string): Promise<BaseData<string>> {
    const url = `/adolescente/${id}/foto`

    return await client.delete<BaseData<string>>(url)
  }
}

export default new TeenagerService()
